import { useTranslation } from 'react-i18next';
import Table from './Table';
import Filter from './Filter';
import Header from './Header';
import CarrierDetail from './CarrierDetail';
import { EmptyState } from '../regureStyles';
import AddCarrierModal from './AddCarrierModal';
import AppLayout from '../../components/AppLayout';
import useRiskCarriersFunctions from './useRiskCarriersFunctions';

const RiskCarriersScreen = () => {
  const { t } = useTranslation();
  const { loading, search, setSearch, selected, setSelected, showAddModal, setShowAddModal, filtered, handleCreate, handleUpdate } = useRiskCarriersFunctions();

  // Carrier detail view
  if (selected) {
    return <CarrierDetail carrier={selected} onBack={() => setSelected(null)} onUpdate={handleUpdate} />;
  }

  return (
    <AppLayout>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        {/* ── Header ──────────────────────────────────────── */}
        <Header setShowAddModal={setShowAddModal} />

        {/* ── Filter bar ───────────────────────────────────── */}
        <Filter search={search} setSearch={setSearch} filtered={filtered} />

        {/* ── Carrier table ────────────────────────────────── */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '0 32px' }}>
          <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
          {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 60 }}>
              <div
                style={{ width: 36, height: 36, border: '3px solid #e2e8f0', borderTopColor: '#7c3aed', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }}
              />
            </div>
          ) : filtered.length === 0 ? (
            <EmptyState icon='building' title={t('screens.riskCarriers.emptyTitle')} subtitle={t('screens.riskCarriers.emptySubtitle')} />
          ) : (
            <Table filtered={filtered} setSelected={setSelected} />
          )}
        </div>
      </div>

      {showAddModal && <AddCarrierModal onClose={() => setShowAddModal(false)} onCreate={handleCreate} />}
    </AppLayout>
  );
};

export default RiskCarriersScreen;
